import { Injectable, createComponent, ApplicationRef, Injector, EmbeddedViewRef, ComponentRef } from '@angular/core';
import { CompletionAnimationComponent } from '../completion-animation/completion-animation.component';
import { CompletionType } from '../models/completion-type.enum';

@Injectable({
    providedIn: 'root'
})
export class CompletionAnimationService {
    private animationComponentRef: ComponentRef<CompletionAnimationComponent> | null = null;

    constructor(
        private appRef: ApplicationRef,
        private injector: Injector
    ) { }

    showCompletionAnimation(
        taskTitle: string, 
        message: string = 'Task Completed!', 
        showPoints: boolean = false, 
        pointsValue: number | null = null,
        completionType: CompletionType = CompletionType.TASK
    ): void {
        // If there's already an animation showing, remove it first
        if (this.animationComponentRef) {
            this.hideCompletionAnimation();
        }

        // Create component
        this.animationComponentRef = createComponent(CompletionAnimationComponent, {
            environmentInjector: this.appRef.injector,
            elementInjector: this.injector,
        });

        // Set default messages based on completion type if not provided
        if (message === 'Task Completed!') {
            switch (completionType) {
                case CompletionType.TODO_ITEM:
                    message = 'Todo Item Completed!';
                    break;
                case CompletionType.ISSUE:
                    message = 'Issue Completed!';
                    break;
            }
        }

        // Set the properties
        this.animationComponentRef.instance.message = message;
        this.animationComponentRef.instance.taskTitle = taskTitle;
        this.animationComponentRef.instance.showPoints = showPoints;
        this.animationComponentRef.instance.pointsValue = pointsValue;
        this.animationComponentRef.instance.completionType = completionType;

        // Attach to the Angular component tree
        this.appRef.attachView(this.animationComponentRef.hostView);

        // Get DOM element from component
        const domElem = (this.animationComponentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;

        // Append to body
        document.body.appendChild(domElem);

        // Auto-remove after animation completes - longer for issues
        const timeout = completionType === CompletionType.ISSUE ? 4000 : 3000;
        setTimeout(() => {
            this.hideCompletionAnimation();
        }, timeout);
    }

    hideCompletionAnimation(): void {
        if (this.animationComponentRef) {
            this.appRef.detachView(this.animationComponentRef.hostView);
            this.animationComponentRef.destroy();
            this.animationComponentRef = null;
        }
    }
}
